<template>
  <div
    class="folder_card"
    v-for="(item, index) in myArray"
    :key="index"
    :class="[item._id + '-card', { 'active-dropdown': activeDropdownId === item._id }]"
  >
    <div
      class="card-body d-flex"
      @dblclick="onDblClickHandler(item.key, item.user_id, item._id)"
      @contextmenu="onContextMenu($event, item)"
    >
      <div class="icon-small" v-if="item.isFileShared == 1">
        <FolderSharedSvg @click="onClickHandler(item.key, item.user_id, item._id)" />
      </div>
      <div class="icon-small" v-else>
        <FolderSvg @click="onClickHandler(item.key, item.user_id, item._id)" />
      </div>
      <h5
        class="m-0"
        @click="onClickHandler(item.key, item.user_id, item._id)"
        style="user-select: none; cursor: pointer"
      >
        {{ item.key }}
      </h5>
      <div class="card-header-toolbar">
        <div class="dropdown" :id="'dropdown-' + item._id">
          <span
            class="dropdown-toggle"
            :id="item._id + '-dropdownMenuButton'"
            data-toggle="dropdown"
          >
            <ThreeDotsSvg />
          </span>
          <div
            class="dropdown-menu dropdown-menu-right"
            :aria-labelledby="item._id + '-dropdownMenuButton'"
            v-if="isMain == 'trash'"
          >
            <a class="dropdown-item" @click.prevent="restoreFolder(item.fullKey)">
              <RestoreSvg />
              <span>Restore</span>
            </a>
            <a
              class="dropdown-item"
              href="javascript:;"
              @click="deleteForeverFolder(item.fullKey)"
              :class="[$store.state.user.userInfo.role_name === 'user' ? 'd-none' : '']"
            >
              <DeleteForeverSvg />
              <span>Delete Forever</span>
            </a>
          </div>
          <div
            class="dropdown-menu"
            aria-labelledby="item._id+'-dropdownMenuButton'"
            v-else
          >
            <a
              class="dropdown-item"
              href="javascript:;"
              @click="downloadFolder(item.fullKey)"
            >
              <DownloadSvg />
              <span>Download</span>
            </a>
            <a
              class="dropdown-item"
              href="javascript:;"
              v-if="isMain != 'sharedWithMe'"
              @click="editFolderName(item.key)"
            >
              <RenameSvg />
              <span>Rename</span>
            </a>
            <a
              class="dropdown-item"
              href="javascript:;"
              @click="shareFolderName(item._id, item.key)"
            >
              <ShareSvg />
              <span>Share</span>
            </a>
            <a
              class="dropdown-item"
              href="javascript:;"
              v-if="isMain != 'sharedWithMe' && item.isFileShared != 1"
              @click="moveFolder(item._id, item.key, item.fullKey, item.user_id)"
            >
              <MoveSvg />
              <span>Move</span>
            </a>
            <a
              class="dropdown-item"
              href="javascript:;"
              @click="starredFolderFile(item._id, item.user_id)"
              v-if="item.starred == '0'"
            >
              <AddToStarredSvg />
              <span>Add to starred</span>
            </a>
            <a
              class="dropdown-item"
              href="javascript:;"
              @click="starredFolderFile(item._id, item.user_id)"
              v-else
            >
              <RemoveToStarredSvg />
              <span>Remove to starred</span>
            </a>
            <a
              class="dropdown-item"
              @click.prevent="deleteFolder(item.fullKey)"
              v-if="isMain != 'sharedWithMe'"
            >
              <MoveToTrashSvg />
              <span>Move to Trash</span>
            </a>
            <a
              class="dropdown-item"
              href="javascript:;"
              @click.prevent="deletePermissionFolder(item._id)"
              v-if="isMain == 'sharedWithMe'"
            >
              <MoveToTrashSvg />
              <span>Remove</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="folder_templates w-100" v-if="$store.state.home.isHomeLoadingMore == true"> -->

  <ShimmerFolder v-if="$store.state.home.isHomeLoadingMore == true" />
  <RenameFolder ref="folderModalRef" />
  <ShareFolder ref="fileShareModalRef" />
  <MoveFolder ref="moveFolderModalRef" />

  <input type="hidden" id="folderName" v-model="folderNamePath" />
  <a
    href="javascript:;"
    data-toggle="modal"
    data-target="#folderDeleteModals"
    class="d-none"
    id="folderDeleteTag"
    >delete</a
  >
  <div
    class="modal fade"
    id="folderDeleteModals"
    tabindex="-1"
    style="display: none"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="staticBackdropLabel"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Move to trash?</h5>
        </div>
        <div class="modal-body">
          <div class="col-12 text-center">
            <!-- <label for="bankName" class="form-label mb-0">This Folder will be deleted from the drive. It
                            will be in Recently Deleted for 30 days.</label> -->
            <label for="bankName" class="form-label mb-0"
              >This Folder will be deleted from the drive.</label
            >
          </div>
        </div>
        <div class="modal-footer">
          <button
            variant="success"
            class="btn btn-primary"
            v-on:click="folderinal()"
            v-if="isDeleteFlag == 1"
          >
            Delete Folder
          </button>
          <button variant="success" class="btn btn-primary" v-else>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
          <button
            variant="outline-primary"
            class="btn btn-secondary"
            id="closeTrashFolderBtn"
            data-dismiss="modal"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
  <context-menu v-model:show="show" :options="optionsComponent">
    <template v-if="activeItem">
      <!-- Trash View -->
      <template v-if="isMain === 'trash'">
        <context-menu-item @click="restoreFolder(activeItem.fullKey)">
          <RestoreSvg />
          <span>Restore</span>
        </context-menu-item>

        <context-menu-item @click="deleteForeverFolder(activeItem.fullKey)">
          <DeleteForeverSvg />
          <span>Delete Forever</span>
        </context-menu-item>
      </template>

      <!-- Other Views -->
      <template v-else>
        <context-menu-item @click="downloadFolder(activeItem.fullKey)">
          <DownloadSvg />
          <span>Download</span>
        </context-menu-item>

        <context-menu-item
          v-if="isMain !== 'sharedWithMe'"
          @click="editFolderName(activeItem.key)"
        >
          <RenameSvg />
          <span>Rename</span>
        </context-menu-item>

        <context-menu-item @click="shareFolderName(activeItem._id, activeItem.key)">
          <ShareSvg />
          <span>Share</span>
        </context-menu-item>

        <context-menu-item
          v-if="isMain !== 'sharedWithMe'"
          @click="
            moveFolder(
              activeItem._id,
              activeItem.key,
              activeItem.fullKey,
              activeItem.user_id
            )
          "
        >
          <MoveSvg />
          <span>Move</span>
        </context-menu-item>

        <context-menu-item
          @click="starredFolderFile(activeItem._id, activeItem.user_id)"
          v-if="activeItem.starred == '0'"
        >
          <AddToStarredSvg />
          <span>Add to Starred</span>
        </context-menu-item>

        <context-menu-item
          @click="starredFolderFile(activeItem._id, activeItem.user_id)"
          v-else
        >
          <RemoveToStarredSvg />
          <span>Remove from Starred</span>
        </context-menu-item>

        <context-menu-item
          v-if="isMain !== 'sharedWithMe'"
          @click="deleteFolder(activeItem.fullKey)"
        >
          <MoveToTrashSvg />
          <span>Move to Trash</span>
        </context-menu-item>

        <context-menu-item
          v-if="isMain === 'sharedWithMe'"
          @click="deletePermissionFolder(activeItem._id)"
        >
          <MoveToTrashSvg />
          <span>Remove</span>
        </context-menu-item>
      </template>
    </template>
  </context-menu>
</template>

<script>
import {
  encodeTextToBase62,
  decodeTextFromBase62,
  downloadFile,
} from "../../utils/helper.js";
import { postCommon } from "../../utils/api.js";
import RenameFolder from "./RenameFolder.vue";
import ShareFolder from "./ShareFolder.vue";
import MoveFolder from "./MoveFolder.vue";
import FolderSvg from "@/components/Widgets/Icon/Folder.vue";
import FolderSharedSvg from "@/components/Widgets/Icon/FolderShared.vue";
import DownloadSvg from "@/components/Widgets/Icon/Download.vue";
import MoveSvg from "@/components/Widgets/Icon/Move.vue";
import RenameSvg from "@/components/Widgets/Icon/Rename.vue";
import ShareSvg from "@/components/Widgets/Icon/Share.vue";
import AddToStarredSvg from "@/components/Widgets/Icon/AddToStarred.vue";
import RemoveToStarredSvg from "@/components/Widgets/Icon/RemoveToStarred.vue";
import MoveToTrashSvg from "@/components/Widgets/Icon/MoveToTrash.vue";
import ThreeDotsSvg from "@/components/Widgets/Icon/ThreeDots.vue";
import DeleteForeverSvg from "@/components/Widgets/Icon/DeleteForever.vue";
import RestoreSvg from "@/components/Widgets/Icon/Restore.vue";
import ShimmerFolder from "./ShimmerFolder.vue";
import $ from "jquery";
import { ContextMenu, ContextMenuItem } from "@imengyu/vue3-context-menu";

export default {
  name: "ChildComponent",
  components: {
    RenameFolder,
    ShareFolder,
    MoveFolder,
    FolderSvg,
    FolderSharedSvg,
    DownloadSvg,
    MoveSvg,
    RenameSvg,
    ShareSvg,
    AddToStarredSvg,
    RemoveToStarredSvg,
    MoveToTrashSvg,
    ThreeDotsSvg,
    DeleteForeverSvg,
    RestoreSvg,
    ShimmerFolder,
    ContextMenu,
    ContextMenuItem,
  },
  data() {
    return {
      folderNamePath: "",
      isDeleteFlag: 1,
      activeDropdownId: null,
      activeItem: null,
      show: false,
      optionsComponent: {
        iconFontClass: "iconfont",
        customClass: "class-a",
        zIndex: 3,
        minWidth: 230,
        x: 500,
        y: 200,
      },
    };
  },
  props: {
    myArray: {
      type: Array,
      required: true, // or false if optional
      default: () => [],
    },
    isMain: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.myArray.forEach((item) => {
        const id = "#dropdown-" + item._id;
        const el = document.querySelector(id);

        if (el) {
          $(el).on("show.bs.dropdown", () => {
            this.activeDropdownId = item._id;
          });

          $(el).on("hide.bs.dropdown", () => {
            this.activeDropdownId = null;
          });
        }
      });
    });
  },
  methods: {
    encodeTextToBase62,
    decodeTextFromBase62,
    postCommon,
    downloadFile,
    folderName(cnt) {
      if (cnt > 1) {
        return "Folders";
      } else {
        return "Folder";
      }
    },
    fileName(cnt) {
      if (cnt > 1) {
        return "Files";
      } else {
        return "File";
      }
    },
    onDoubleClick(item, user_id,_id) {
      console.log(item);
      localStorage.setItem("aid", user_id);
      if (this.isMain == "trash") {
        return false;
      }
      let nameEnCode = this.encodeTextToBase62(item);
      let idEnCode = this.encodeTextToBase62(_id);
      let Folderpaths = "";
      let Midpaths = "";
      if (!this.$route.query.path || this.$route.query.path.trim() === "") {
        Folderpaths = "";
      } else {
        Folderpaths = this.$route.query.path;
        Midpaths = this.$route.query.mid;
        nameEnCode = Folderpaths + "/" + nameEnCode;
        idEnCode = Midpaths + "/" + idEnCode;
      }
      this.$router.push({
        name: "Folder",
        query: {
          path: nameEnCode,
          aid: user_id,
          mid: idEnCode,
        },
      });
    },
    editFolderName(name) {
      this.$refs.folderModalRef.renameFolder(name);
    },
    shareFolderName(_id, name) {
      // console.log('shareFolderName', _id, name);
      this.$refs.fileShareModalRef.shareFileModal(_id, name);
    },
    moveFolder(_id, name, fullKey, user_id) {
      this.$refs.moveFolderModalRef.openMoveFolder(_id, name, fullKey, user_id);
    },
    async starredFolderFile(name, user_id) {
      let _post = {};
      _post = {
        // fullKey: Folderpaths,
        _id: name,
        user_id: user_id,
      };
      const resp = await postCommon("starred/add-to-starred", _post);
      if (resp.status == 200 && resp.data.status == "success") {
        this.$toast.success(resp.data.message);
        // this.$store.state.home.reLoadFileHomeStarredComponent = Math.random();
        this.$store.state.home.reLoadFolderHomeStarredComponent = Math.random();
      } else if (resp.status == 200 && resp.data.status == "failure") {
        this.errorMessage = resp.data.message;
      }
      this.formLoader = 1;
    },
    async folderinal() {
      this.isDeleteFlag = 2;
      let _post = {};
      _post = {
        folderName: this.folderNamePath,
      };
      const resp = await postCommon("files/delete-folder", _post);
      if (resp.status == 200 && resp.data.status == "success") {
        this.$toast.success(resp.data.message);
        // this.$store.state.home.reLoadFolder = Math.random();
        // this.$store.state.home.reLoadPathFolder = Math.random();
        this.$store.state.home.reLoadFoldercomponent = Math.random();
        document.getElementById("closeTrashFolderBtn").click();
      } else if (resp.status == 200 && resp.data.status == "failure") {
        this.errorMessage = resp.data.message;
      }
      this.isDeleteFlag = 1;
      this.formLoader = 1;
    },
    async downloadFolder(fullKey) {
      let _post = {};
      _post = {
        folderName: fullKey,
      };
      const resp = await postCommon("files/download-folder", _post);
      if (resp.status == 200 && resp.data.status == "success") {
        this.downloadFile(resp.data.data.downloadUrl);
        this.$toast.success(resp.data.message);
      } else if (resp.status == 200 && resp.data.status == "failure") {
        this.errorMessage = resp.data.message;
      }
      this.formLoader = 1;
    },
    async deleteFolder(folder) {
      this.folderNamePath = folder;
      document.getElementById("folderDeleteTag").click();
    },
    async deletePermissionFolder(file) {
      let _post = {};
      _post = {
        _id: file,
      };
      const resp = await postCommon("files/delete-file-permission", _post);
      if (resp.status == 200 && resp.data.status == "success") {
        this.$toast.success(resp.data.message);
        this.$store.state.home.reLoadFoldercomponent = Math.random();
      } else if (resp.status == 200 && resp.data.status == "failure") {
        this.errorMessage = resp.data.message;
      }
      this.formLoader = 1;
    },
    async deleteForeverFolder(fileName) {
      let _post = {};
      _post = {
        folderName: fileName,
      };
      const resp = await postCommon("/files/forever-delete-folder", _post);
      if (resp.status == 200 && resp.data.status == "success") {
        this.$toast.success(resp.data.message);
        // this.$store.state.home.reLoadFolder = Math.random();
        this.$store.state.home.reLoadPathFolder = Math.random();
        this.$store.state.home.reLoadFoldercomponent = Math.random();
        document.getElementById("closeTrashBtn").click();
      } else if (resp.status == 200 && resp.data.status == "failure") {
        this.errorMessage = resp.data.message;
      }
      this.formLoader = 1;
    },
    async restoreFolder(fileName) {
      let _post = {};
      _post = {
        folderName: fileName,
      };
      const resp = await postCommon("files/restore-folder", _post);
      if (resp.status == 200 && resp.data.status == "success") {
        this.$toast.success(resp.data.message);
        // this.$store.state.home.reLoadFolder = Math.random();
        // this.$store.state.home.reLoadPathFolder = Math.random();
        this.$store.state.home.reLoadFoldercomponent = Math.random();
        document.getElementById("closeTrashBtn").click();
      } else if (resp.status == 200 && resp.data.status == "failure") {
        this.errorMessage = resp.data.message;
      }
      this.formLoader = 1;
    },
    onContextMenu(e, item) {
      e.preventDefault();

      $(".dropdown-menu").removeClass("show"); // manually close any Bootstrap dropdown
      $(".dropdown-toggle").dropdown("hide"); // in case it's toggled

      this.activeDropdownId = item._id;

      //Set the mouse position
      this.optionsComponent.x = e.x;
      this.optionsComponent.y = e.y;
      this.activeItem = item;
      //Show menu
      this.show = true;
    },
    isMobile() {
      return /Mobi|Android/i.test(navigator.userAgent);
    },
    onDblClickHandler(item, user_id, _id) {
      if (!this.isMobile()) {
        this.handleOpen(item, user_id, _id);
      }
    },
    onClickHandler(item, user_id, _id) {
      if (this.isMobile()) {
        this.handleOpen(item, user_id, _id);
      }
    },
    handleOpen(item, user_id, _id) {
      this.onDoubleClick(item, user_id, _id);
    },
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        this.activeDropdownId = null;
      }
    },
  },
};
</script>
